import { request } from './client';
import { UserResponse, UpdateUserPayload, UpdatePasswordPayload } from './types';
import { Id } from '../types';

export function getMe(): Promise<UserResponse> {
  return request<UserResponse>('/users/me');
}

export function updateUser(
  id: Id,
  payload: UpdateUserPayload
): Promise<UserResponse> {
  return request<UserResponse>(`/users/${id}`, {
    method: 'PUT',
    body: JSON.stringify(payload),
  });
}

export function updatePassword(
  id: Id,
  payload: UpdatePasswordPayload
): Promise<UserResponse> {
  return request<UserResponse>(`/users/${id}/password`, {
    method: 'PUT',
    body: JSON.stringify(payload),
  });
}
